define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/AttributeController",
	"csi/middleware/rollup/Processor",
	"csi/xml"
], function (declare, _, AttributeController, Processor, xml) {

	return declare(AttributeController, {
		_toWriterAttribute: function (/*String*/id, /*String*/type) {
			// summary: disable expression, publishing client's value as the disabled value in case it has gone through clinet-side
			// rollup and is more up-to-date than the server value
			var node = this.getNode();
			var cn = this.m_writer.changeNode(this.m_urlNode);
			var rp = new Processor(node, this.m_cache, this.getContext());

			cn.disableAttributeExp(id);
			cn.changeAttribute(id, type, rp.evaluateAttribute(id, node));

			// disable sub-headings if also on same node and have expression
			_.each(this.heading.m_subheadings, function (sh) {
				if (!sh.m_path && xml.nodeAttributeHasExpression(node, sh.m_id, true)) {
					cn.disableAttributeExp(sh.m_id);
					cn.changeAttribute(sh.m_id, sh.getAttrType(), rp.evaluateAttribute(sh.m_id, node));
				}
			});

			// notify that attribute expression was disabled
			this._notifyOfChange(cn, node, id, false, true);
		}
	});
});